import React, { useEffect, useState } from "react";
import "../assets/css/Hero.css";
import heroImage from "../assets/imgs/hero.png";

const Hero = () => {

    const [showText, setShowText] = useState(false);
    const [showButtons, setShowButtons] = useState(false);

    const [mousePosition, setMousePosition] = useState({
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
    });

    useEffect(() => {

        const handleMouseMove = (e) => {
            setMousePosition({
                x: e.clientX,
                y: e.clientY
            });
        };

        window.addEventListener("mousemove", handleMouseMove);

        setTimeout(() => {
            setShowText(true);
        }, 2500);

        setTimeout(() => {
            setShowButtons(true);
        }, 3500);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
        };

    }, []);

    return (
        <section className="hero">

            <div
                className="hero-bg"
                style={{ backgroundImage: `url(${heroImage})` }}
            ></div>

            <div
                className="spotlight"
                style={{
                    background: `radial-gradient(
            circle at ${mousePosition.x}px ${mousePosition.y}px,
            rgba(255,255,255,0.35) 0px,
            rgba(0,0,0,0.6) 200px,
            rgba(0,0,0,0.95) 450px
          )`
                }}
            ></div>

            <div className="hero-content">

                <h1 className={`hero-title ${showText ? "show" : ""}`}>
                    The Mind Behind Business Transformation
                </h1>

                <div className={`hero-buttons ${showButtons ? "show" : ""}`}>

                    <button className="btn-outline">
                        Watch The Vision
                    </button>

                    <button className="btn-gold">
                        Enter The Experience
                    </button>

                </div>

            </div>

        </section>
    );
};

export default Hero;